import React, { useState, useEffect } from 'react'
import HOCButton from 'web/components/Button';
import { Form, Formik, Field } from 'formik';
import * as moment from 'moment';
import RadioButton from 'web/components/form-elements/RadioButton';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import CsvDownloader from 'react-csv-downloader';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

export default function ExportModal(props) {

    const [selectOption, setSelectOption] = useState('All')
    const [selectedColumns, setSelectedColumns] = useState([])
    let csvHeaders = [
        { displayName: 'User Name', id: 'UserName', order: 1 },
        { displayName: 'Email Id', id: 'Email', order: 2 },
        { displayName: 'Company Name', id: 'Company', order: 3 },
        { displayName: 'City', id: 'City', order: 5 },
        { displayName: 'State', id: 'State', order: 6 },
        { displayName: 'Zip', id: 'Zip', order: 7 },
        { displayName: 'Account Type', id: 'AccountType', order: 8 },
        { displayName: 'Broker', id: 'Broker', order: 9 },
        { displayName: 'FC Member', id: 'FCMember', order: 10 },
        { displayName: 'Heard From', id: 'HeardFrom', order: 11 },
        { displayName: 'Acknowledged Version', id: 'AcknowledgedVersion', order: 12 },
        { displayName: 'Acknowledged Name ', id: 'AcknowledgedName', order: 13 },
        { displayName: 'Acknowledged Date', id: 'AcknowledgedDate', order: 14 },
    ]
    const [csvHeaderArray, setCsvHeaderArray] = useState(csvHeaders)
    const [csvData, setCsvData] = useState([])

    useEffect(() => {
        let tempData = JSON.parse(JSON.stringify(props.dataList))
        let tempCSVDate = tempData?.map(items => {
            return ({
                UserName: items.name?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                Email: items.email,
                Company: items.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                City: items.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ")?.trim(),
                State: stateConvert(items.state?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ")?.trim()),
                Zip: items.zip,
                AccountType: items.accountType === 'USER_GUEST' ? 'Guest' : (items.buyer && items.seller) ? 'Both' : items.buyer ? 'Buyer' : items.seller ? 'Seller' : 'NA',
                Broker: items.reseller ? 'Yes' : 'No',
                FCMember: items.innerCircle ? 'Yes' : 'No',
                HeardFrom: items.hearAbout ? items.hearAbout?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ") : '',
                AcknowledgedVersion: items.termsAndConditionsVersion,
                AcknowledgedName: items.acknowledgedName?.replaceAll("\n", " "),
                AcknowledgedDate: items.acknowledgedCreateTime > 0 ? moment(items.acknowledgedCreateTime * 1000).format("MM-DD-YYYY") : '',
            })
        })       
        setCsvData(tempCSVDate)
    }, [])

    const setColumnstoCsvHeaders = data => {
        let tempData = JSON.parse(JSON.stringify(csvHeaders))
        let tempDataFinal = []
        data.map(val => {
            tempData.map(data => {
                if (data.id === val) tempDataFinal.push(data)
                return null
            })
        })
        tempDataFinal.sort((a, b) => {
            return a.order - b.order;
        })
        if (selectOption === 'All') setCsvHeaderArray(csvHeaders)
        else setCsvHeaderArray(tempDataFinal)
    }

    const selectOptions = [{ label: 'All Fields', value: 'All' },
    { label: 'Custom Fields', value: 'Custom' }]

    const exportReport = () => {
        props.onEnter()
    }

    const getInitialValues = {
        selectOptions: 'All'
    }
    const VALIDATION_SCHEMA = () => {
    }

    return (
        <div>
            <Formik
                initialValues={getInitialValues}
                validationSchema={VALIDATION_SCHEMA()}
                onSubmit={(values) => {
                }}>
                {() => {
                    return (
                        <>
                            <Form>
                                <p className="mt-0" style={{ fontWeight: 'bold' }}>Columns</p>
                                <div className="mt-3" style={{ display: 'flex' }}>
                                    {selectOptions.map((value, index) => (
                                        <div key={index} style={{ paddingRight: '25px' }}>
                                            <Field
                                                component={RadioButton}
                                                name='selectOptions'
                                                id={value.value}
                                                defaultValue={selectOptions[0].value}
                                                onSelect={(e) => {
                                                    setSelectOption(e.target.value)
                                                    if (e.target.value === 'All') setCsvHeaderArray(csvHeaders)
                                                }}
                                                label={value.label}
                                            />
                                        </div>
                                    ))}
                                </div>
                                {selectOption === 'Custom' &&
                                    <>
                                        <p className="mt-2" style={{ fontWeight: 'bold' }}>Select Columns</p>
                                        <div className="row">
                                            {csvHeaders.map((value, i) => (
                                                <div className="col-md-4">
                                                    <CheckboxInput
                                                        name={value.displayName}
                                                        label={value.displayName}
                                                        handleSelect={(val, label, flag) => {
                                                            let selectedValue = csvHeaders.filter(val => val.displayName === label)
                                                            let tempValue = selectedColumns
                                                            if (flag && !tempValue.includes(selectedValue[0].id)) tempValue.push(selectedValue[0].id)
                                                            else if (!flag) tempValue = tempValue.filter(val => val !== selectedValue[0].id)
                                                            setSelectedColumns(tempValue)
                                                            setColumnstoCsvHeaders(tempValue)
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }
                                <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'end' }}>
                                    <CsvDownloader
                                        filename="User Details Report"
                                        columns={csvHeaderArray}
                                        datas={csvData}>
                                        <HOCButton
                                            type='app-green-button submitBtn'
                                            handleClick={() => exportReport()}
                                            disabled={selectOption === 'Custom' && selectedColumns.length < 1}>
                                            Export
                                        </HOCButton>
                                    </CsvDownloader>
                                </div>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div>
    )
}